import PropTypes from 'prop-types';

export const objectExpansionPanelShape = PropTypes.shape({
  title: PropTypes.string,
  expanded: PropTypes.bool,
});
export const styleExpansionPanelShape = PropTypes.shape({
  panel: PropTypes.shape({
    backgroundColor: PropTypes.string,
  }),
});

export const objectExpansionPanelDefault = {
  title: '',
  expanded: true,
};
export const styleExpansionPanelDefault = {
  panel: {
    backgroundColor: 'rgb(187,233,255)',
  },
};
